export default __webpack_public_path__ + "static/media/sellhistory.762e92eb.svg";